import { ObjectUtils } from 'primereact/utils';

export const getTablePreferences = () => {
  let columnPreferences = localStorage.getItem(
    'tableColumnsVisibilityPreferences',
  );

  if (!columnPreferences) {
    columnPreferences = JSON.stringify({});
    localStorage.setItem(
      'tableColumnsVisibilityPreferences',
      columnPreferences,
    );
  }

  return columnPreferences;
};

export enum PreviewType {
  TABLE = 'table',
  GRID = 'grid',
}

export const previewOptions = [
  { icon: 'pi pi-list', value: PreviewType.TABLE },
  { icon: 'pi pi-th-large', value: PreviewType.GRID },
];

export const snapRowsPerPage = (options: number[], rows?: number): number => {
  const ascending = [...options].sort((first, second) => first - second);

  if (!rows) {
    return ascending[0];
  }

  return (
    ascending.find((option) => option >= rows) ??
    ascending[ascending.length - 1]
  );
};

export const findDuplicateRowKeys = (
  rows: Record<string, any>[] | undefined,
  dataKey: string,
): string[] => {
  const counts = new Map<string, number>();
  rows?.forEach((row) => {
    const value = ObjectUtils.resolveFieldData(row, dataKey);
    if (value === undefined || value === null) {
      return;
    }
    const key = String(value);
    counts.set(key, (counts.get(key) ?? 0) + 1);
  });

  return [...counts.entries()]
    .filter(([, count]) => count > 1)
    .map(([key]) => key);
};
